<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} check-in điểm đến an toàn</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} check-in điểm đến an toàn</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} check-in điểm đến an toàn</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="6">
              <el-form-item label="Người check-in" prop>
                <!-- <el-input
                  type="text"
                  v-model="mData.dataForm.nguoi_check_in_id"
                  :disabled="mData.viewMode != 'create'"
                  clearable
                ></el-input>-->
                <el-select
                  v-model="mData.dataForm.nguoi_check_in_id"
                  clearable
                  filterable
                  :disabled="mData.viewMode == 'detail'"
                  placeholder="Nhập từ khóa để tìm kiếm"
                  no-data-text="Chưa có dữ liệu"
                  :filter-method="fn_findNguoiCheckin"
                >
                  <el-option
                    v-for="item in mData.dataDefault.listFindNguoiCheckin"
                    :key="item.id"
                    :label="item.ho_ten.ho_ten"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Điểm đến an toàn" prop>
                <!-- <el-input
                  type="text"
                  v-model="mData.dataForm."diem_den_an_toan_id"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>-->
                <el-select
                  v-model="mData.dataForm.diem_den_an_toan_id"
                  clearable
                  :disabled="mData.viewMode == 'detail'"
                  filterable
                  placeholder="Nhập từ khóa để tìm kiếm"
                  no-data-text="Chưa có dữ liệu"
                  :filter-method="fn_findDDAT"
                >
                  <el-option
                    v-for="item in mData.dataDefault.listFindDDAT"
                    :key="item.id"
                    :label="item.thong_tin_chung.ten"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>
          <b-row v-if="mData.viewMode == 'detail'">
            <b-col md="6">
              <el-form-item label="Thời điểm check-in" prop>
                <el-date-picker
                  type="datetime"
                  v-model="mData.dataForm.thoi_diem_check_in"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  :disabled="mData.viewMode == 'detail'"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                >clearable</el-date-picker>
              </el-form-item>
            </b-col>
            <b-col md="6">
              <el-form-item label="Người tạo" prop>
                <!-- <el-input
                  type="text"
                  v-model="mData.dataForm.nguoi_tao_id"
                  :disabled="mData.viewMode == 'detail'"
                  
                  clearable
                ></el-input>-->
                <el-select
                  v-model="mData.dataForm.nguoi_tao_id"
                  clearable
                  filterable
                  :disabled="mData.viewMode == 'detail'"
                  placeholder="Nhập từ khóa để tìm kiếm"
                  no-data-text="Chưa có dữ liệu"
                  :filter-method="fn_findNguoiTao"
                >
                  <el-option
                    v-for="item in mData.dataDefault.listFindNguoiTao"
                    :key="item.id"
                    :label="item.ho_ten.ho_ten"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button>

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import CheckinDDATModel from "./CheckinDDATModel";
import CheckinDDATApi from "../../../moduleApi/CheckinDDATApi";
import DiemDenAnToanApi from "../../../moduleApi/DiemDenAnToanApi";
import ProfileApi from "../../../moduleApi/ProfileApi";
import KhachDuLichApi from "../../../moduleApi/KhachDuLichApi";

export default {
  data() {
    return {
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "CheckinDDAT",
        dataDefault: {
          roles: DataService.rolesInForm,
          listFindNguoiCheckin: [],
          listFindDDAT: [],
          listFindNguoiTao: []
        },
        dataForm: MethodService.copyObject(CheckinDDATModel.dataForm),
        validForm: CheckinDDATModel.validForm,
        dialog: {}
      }
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          if (type == "create") {
            await CheckinDDATApi.create(this.mData.dataForm);
            this.fn_resetForm();
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await CheckinDDATApi.update(this.mData.dataForm);
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await CheckinDDATApi.findById(id);

      if (res.result.nguoi_check_in_id) {
        let resProfile = await KhachDuLichApi.findById(
          res.result.nguoi_check_in_id
        );
        if (resProfile.result) {
          this.mData.dataDefault.listFindNguoiCheckin.push(resProfile.result);
        }
      }

      if (res.result.diem_den_an_toan_id) {
        let resDDAT = await DiemDenAnToanApi.findById(
          res.result.diem_den_an_toan_id
        );

        if (resDDAT.result) {
          this.mData.dataDefault.listFindDDAT.push(resDDAT.result);
        }
      }

      if (res.result.nguoi_tao_id) {
        let resProfileTao = await ProfileApi.findById(res.result.nguoi_tao_id);
        if (resProfileTao.result) {
          this.mData.dataDefault.listFindNguoiTao.push(resProfileTao.result);
        }

        let resKDLTao = await KhachDuLichApi.findById(res.result.nguoi_tao_id);
        if (resKDLTao.result) {
          this.mData.dataDefault.listFindNguoiTao.push(resKDLTao.result);
        }
      }

      this.mData.dataForm = res.result;
    },
    async fn_findNguoiCheckin(query) {
      if (!query) {
        return;
      }
      let resProfile = await KhachDuLichApi.list({
        limit: 1000,
        filters: `ho_ten.ho_ten:regex_i:${query}`
      });
      if (resProfile.result && resProfile.result.length > 0) {
        this.mData.dataDefault.listFindNguoiCheckin = resProfile.result;
      }
    },
    async fn_findNguoiTao(query) {
      if (!query) {
        return;
      }
      // debugger;
      let resProfile = await ProfileApi.list({
        limit: 1000,
        filters: `ho_ten.ho_ten:regex_i:${query}`
      });
      if (resProfile.result && resProfile.result.length > 0) {
        this.mData.dataDefault.listFindNguoiTao = resProfile.result;
      } else {
        let resKDL = await KhachDuLichApi.list({
          limit: 1000,
          filters: `ho_ten.ho_ten:regex_i:${query}`
        });
        if (resKDL.result && resKDL.result.length > 0) {
          this.mData.dataDefault.listFindNguoiTao = resKDL.result;
        }
      }
    },
    async fn_findDDAT(query) {
      if (!query) {
        return;
      }
      let resDDAT = await DiemDenAnToanApi.list({
        limit: 1000,
        filters: `thong_tin_chung.ten:regex_i:${query}`
      });
      if (resDDAT.result && resDDAT.result.length > 0) {
        this.mData.dataDefault.listFindDDAT = resDDAT.result;
      }
    },
    async fn_initDataDefault() {},

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    }
  },
  created: function() {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function() {}
};
</script>